import styled from "styled-components"
import media from "styled-media-query"
import { Link } from "gatsby"

export const RecommendedWrapper = styled.section`
  border-bottom: 1px solid var(--texts);
  border-top: 1px solid var(--texts);
  display: flex;
`

export const RecommendedLink = styled(Link)`
  align-items: center;
  background: var(--primary);
  color: var(--textsWhite);
  font-size: 18px;
  font-weight: bold;
  display: flex;
  padding: 3rem;
  text-decoration: none;
  transition: opacity 0.3s;
  width: 50%;

  svg {
    margin: 0 5px;
  }

  &:hover {
    opacity: 0.8;
  }
  &.previous {
    border-right: 1px solid var(--texts);
  }
  &.next {
    justify-content: flex-end;
  }

  ${media.lessThan("small")`
      padding: 1.5rem;
      font-size: 14px;
  `}
`
